import Form from 'antd/es/form/index'
import { UserManagementNormalForm } from './user-management-normal-form.tsx'
import Input from 'antd/es/input/Input'
import { UserManagementFormFieldTypes } from './user-management-form.tsx'
import { FormInstance } from 'antd/lib/index'
import { useTranslation } from 'react-i18next'
import {
  formatInternalEmailDomains,
  isInternalEmail,
} from '@/utils/constants.ts'

interface UserManagementExternalFormProps {
  form: FormInstance<UserManagementFormFieldTypes>
}

export const UserManagementExternalForm: React.FC<
  UserManagementExternalFormProps
> = ({ form }) => {
  const { t, i18n } = useTranslation()
  const firmRole = Form.useWatch('firmRole', form)

  return (
    <>
      <Form.Item
        label={t('user_management.user_modal.form.full_name')}
        name={'fullName'}
        rules={[
          {
            required: true,
            message: t(
              'user_management.user_modal.form.please_input_full_name'
            ),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t('user_management.user_modal.form.email')}
        name={'email'}
        rules={[
          {
            required: true,
            message: t('user_management.user_modal.form.please_input_email'),
          },
          {
            type: 'email',
            message: t(
              'user_management.user_modal.form.please_enter_valid_email'
            ),
          },
          {
            validator: (_, value) => {
              if (!value || !isInternalEmail(value)) {
                return Promise.resolve()
              }
              return Promise.reject(
                new Error(
                  t('user_management.user_modal.form.email_domain_error', {
                    domains: formatInternalEmailDomains(
                      i18n.resolvedLanguage ?? i18n.language
                    ),
                    interpolation: { escapeValue: false },
                  })
                )
              )
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
      <UserManagementNormalForm form={form} />
      {firmRole === 'Normal' && (
        <Form.Item
          label={t('user_management.user_modal.form.external_id')}
          name={'externalId'}
        >
          <Input />
        </Form.Item>
      )}
    </>
  )
}
